import { authorizeGetRequest, authorizePutRequest } from "api";
import { IPaginatedResponse } from "models";
import {
  IReportRequest,
  IReportRequestUpdateStatus,
  IReportRequestUpdateStatusResponse,
} from "models/reportRequest";

export const reportRequestsApi = (
  page: number,
  perPage: number,
  search: string
) => {
  return authorizeGetRequest<IPaginatedResponse<IReportRequest>>(
    `report-requests?page=${page}&per_page=${perPage}&search=${search}`
  );
};

export const updateReportRequestStatusApi = (
  id: string,
  data: IReportRequestUpdateStatus
) => {
  return authorizePutRequest<IReportRequestUpdateStatusResponse>(
    `report-requests/${id}/status`,
    data
  );
};
